import {
  DeleteSystemUserRequest,
  DeleteSystemUserRequestToJSON,
  HTTPBody,
  RegisterSystemUserRequest,
  RegisterSystemUserRequestToJSON,
  ResetSystemUserPasswordRequest,
  ResetSystemUserPasswordRequestToJSON,
  SystemUser,
  SystemUserFromJSON,
  UpdateSystemUserPasswordRequest,
  UpdateSystemUserPasswordRequestToJSON,
  UpdateSystemUserRequest,
  UpdateSystemUserRequestToJSON
} from '@/api'
import * as runtime from '../runtime'

export class SystemUserApi extends runtime.BaseAPI {
  /**
   * システムユーザーの一覧を取得する
   * システムユーザー一覧取得
   */
  async getSystemUsers(): Promise<SystemUser[]> {
    const response = await this.requestGet(`/system-users`)

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(SystemUserFromJSON)
    ).value()
  }

  /**
   * システムユーザーを取得する
   * システムユーザー取得
   */
  async getSystemUser(id: string): Promise<SystemUser> {
    const response = await this.requestGet(`/system-users/${id}`)

    return new runtime.JSONApiResponse(response, jsonValue =>
      SystemUserFromJSON(jsonValue)
    ).value()
  }

  /**
   * システムユーザーを登録する
   * システムユーザー登録
   */
  async registerSystemUser(
    request: RegisterSystemUserRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = RegisterSystemUserRequestToJSON(request)

    const response = await this.requestPost('/system-users', bodyParameters)

    return new runtime.VoidApiResponse(response)
  }

  /**
   * システムユーザーを更新する
   * システムユーザー更新
   */
  async updateSystemUser(
    request: UpdateSystemUserRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = UpdateSystemUserRequestToJSON(request)

    const response = await this.requestPut(
      `/system-users/${request.id}`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * システムユーザーを削除する
   * システムユーザー削除
   */
  async deleteSystemUser(
    request: DeleteSystemUserRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = DeleteSystemUserRequestToJSON(request)

    const response = await this.requestDelete(
      `/system-users/${request.id}`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * システムユーザーパスワードを初期化する
   * システムユーザーパスワード初期化
   */
  async resetSystemUserPassword(
    request: ResetSystemUserPasswordRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = ResetSystemUserPasswordRequestToJSON(
      request
    )

    const response = await this.requestPut(
      `/system-users/${request.id}/password-reset`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * システムユーザーのパスワードを更新する
   * システムユーザーパスワード更新
   */
  async updateSystemUserPassword(
    request: UpdateSystemUserPasswordRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = UpdateSystemUserPasswordRequestToJSON(
      request
    )

    const response = await this.requestPut(
      `/system-users/password`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }
}
